import AmphibianIcon from '../icons/Amphibian'
import BirdIcon from '../icons/Bird'
import CatIcon from '../icons/Cat'
import CowIcon from '../icons/Cow'
import DogIcon from '../icons/Dog'
import FerretIcon from '../icons/Ferret'
import FishIcon from '../icons/Fish'
import GoatIcon from '../icons/Goat'
import HorseIcon from '../icons/Horse'
import LargeAnimalIcon from '../icons/LargeAnimal'
import MonkeyIcon from '../icons/Monkey'
import MouseIcon from '../icons/Mouse'
import PigIcon from '../icons/Pig'
import RabbitIcon from '../icons/Rabbit'
import ReptileIcon from '../icons/Reptile'
import SheepIcon from '../icons/Sheep'
import SmallAnimalIcon from '../icons/SmallAnimal'

enum Animal {
  CAT = 'Feline',
  DOG = 'Canine',
  AMPHIBIAN = 'Amphibian',
  FISH = 'Aquatic',
  BIRD = 'Avian',
  COW = 'Bovine',
  GOAT = 'Caprine',
  HORSE = 'Equine',
  RABBIT = 'Lagomorph',
  FERRET = 'Mustelidae',
  SHEEP = 'Ovine',
  PIG = 'Porcine',
  REPTILE = 'Reptilian',
  MOUSE = 'Rodent',
  MONKEY = 'Simian',
  SMALL_OTHER = 'Small Animal, Other',
  LARGE_OTHER = 'Large Animal, Other',
}

export const AnimalIcons = {
  [Animal.CAT]: CatIcon,
  [Animal.DOG]: DogIcon,
  [Animal.AMPHIBIAN]: AmphibianIcon,
  [Animal.FISH]: FishIcon,
  [Animal.BIRD]: BirdIcon,
  [Animal.COW]: CowIcon,
  [Animal.GOAT]: GoatIcon,
  [Animal.HORSE]: HorseIcon,
  [Animal.RABBIT]: RabbitIcon,
  [Animal.FERRET]: FerretIcon,
  [Animal.SHEEP]: SheepIcon,
  [Animal.PIG]: PigIcon,
  [Animal.REPTILE]: ReptileIcon,
  [Animal.MOUSE]: MouseIcon,
  [Animal.MONKEY]: MonkeyIcon,
  [Animal.SMALL_OTHER]: SmallAnimalIcon,
  [Animal.LARGE_OTHER]: LargeAnimalIcon,
}

export default Animal
